import { ReactNode } from "react"
import { Helmet } from "react-helmet"
import { API } from "../../constants/constants"

export type BaseLayoutType = {
    seo?: {
        title: string
        canonicalURL: string
        description: string
        keywords: string
    }
    children: ReactNode
    logo?: string
}

export default function BaseLayout({ seo, logo, children }: BaseLayoutType) {
    return (
        <section className="grow w-full flex flex-col items-center justify-start bg-accent">
            <Helmet>
                <title>{seo?.title}</title>
                <link rel="icon" href={API + logo} />
                <link rel="icon" type="image/png" href={API + logo} />
                <link rel="apple-touch-icon" href={API + logo} />
                {seo?.canonicalURL && <link rel="canonical" href={seo?.canonicalURL} />}
                {seo?.description && (
                    <meta
                        name="description"
                        content={seo?.description ?? "Das ist die Website der Hallischen Behindertenwerke - von Menschen für Menschen"}
                    />
                )}
                {seo?.description && (
                    <meta
                        name="og:description"
                        content={seo?.description ?? "Das ist die Website der Hallischen Behindertenwerke - von Menschen für Menschen"}
                    />
                )}
                {seo?.keywords && <meta name="keywords" content={seo?.keywords} />}
            </Helmet>
            {children}
        </section>
    )
}
